module.exports = __webpack_public_path__ + "dingbeauty-build/img/pet_avator@2.2f056859.png";